const buildRow = (images, startIdx, containerWidth, height, margin) => {
    const sz = images.length;
    let len = 0, totalWidth = 0;
    const row = [];
    let i = startIdx;
    let sumScales = 0, sumScalesPrev = 0;
    for (; i < sz; ++i) {
        const image = images[i];
        const scale = image.width / image.height;
        const scaledWidthFloat = scale * height;
        const scaledWidth = Math.floor(scaledWidthFloat);
        row.push({idx: i, width: scaledWidth, imgWidth: scaledWidth, height, marginLeft: 0, margin});
        len += scaledWidth + (i > startIdx ? margin : 0);
        totalWidth += scaledWidth;
        sumScales += scale;
        if (len >= containerWidth) {
            sumScalesPrev = sumScales - scale;
            break;
        }
    }
    const delta = len - containerWidth;
    let remainingDelta = delta;
    if (delta > 0) {
        if (delta > row.length) {
            // distribute delta as left margins proportional to widths
            for (let k = 0; k < row.length; ++k) {
                const cutoff = Math.floor(delta * row[k].width / totalWidth);
                remainingDelta -= cutoff;
                row[k].width -= cutoff;
                row[k].marginLeft = -Math.floor(cutoff / 2);
            }
            if (remainingDelta > row.length) {
                throw Error('Coding error');
            }
        }
        // distribute remaining delta among widths
        for (let j = 0; j < remainingDelta; ++j) {
            row[j].width--;
        }
    }
    const count = row.length;
    return {
        endIdx: i + 1,
        row,
        delta,
        normalizedDelta: delta / len,
        height,
        hLow: Math.ceil((containerWidth - (count - 1) * margin) / sumScales),
        hHigh: Math.floor((containerWidth - (count - 1) * margin + 2 * count) / sumScales),
        hPrevLow: Math.ceil((containerWidth - (count - 2) * margin) / sumScalesPrev),
        hPrevHigh: Math.floor((containerWidth - (count - 2) * margin + 2 * (count - 1)) / sumScalesPrev),
    };
};


export const imageGrid = (images, containerWidth, defaultHeight = 220, margin = 2) => {
    const sz = images.length;
    let startsIdx = 0;
    const rows = [];
    while (startsIdx < sz) {
        let rowInfo = buildRow(images, startsIdx, containerWidth, defaultHeight, margin);
        let minDelta = rowInfo.normalizedDelta;
        const {hLow, hHigh, hPrevLow, hPrevHigh} = rowInfo;
        for (let h = hHigh; h >= hLow && minDelta > 0; --h) {
            if (h <= 0) {
                continue;
            }
            const ri = buildRow(images, startsIdx, containerWidth, h, margin);
            if (ri.normalizedDelta < minDelta) {
                rowInfo = ri;
                minDelta = ri.normalizedDelta;
            }
        }
        for (let h = hPrevLow; h <= hPrevHigh && minDelta > 0; ++h) {
            if (h <= 0) {
                continue;
            }
            const ri = buildRow(images, startsIdx, containerWidth, h, margin);
            if (ri.normalizedDelta < minDelta) {
                rowInfo = ri;
                minDelta = ri.normalizedDelta;
            }
        }

        rows.push(rowInfo.row);
        startsIdx = rowInfo.endIdx;
    }
    return rows;
};



// WEBPACK FOOTER //
// ./src/imageGrid.js